export default __webpack_public_path__ + "static/supermarket-logo-8cd969b36e0d8c9ee533b753c08d568f.png";